export function encodeParams(params) {
  return Object.entries(params)
    .map(param => param.map(s => encodeURIComponent(s)).join('='))
    .join('&');
}

export function encodeURL(url, params) {
  return [url, encodeParams(params)].filter(s => s && s.length).join('?');
}
